import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import ShoppingBasketSummaryCoverable from './ShoppingBasketSummaryCoverable';

const ShoppingBasketSummaryCoverableList = ({
    coverables,
    paymentFrequencyPostfix,
    paymentFrequency,
    shouldRenderOverlayDesign = false
}: {
    coverables: CoverableDTO[];
    paymentFrequencyPostfix: string;
    paymentFrequency: DSSPaymentFrequency;
    shouldRenderOverlayDesign?: boolean;
}): React.JSX.Element => {
    return (
        <div>
            {coverables.map((coverable) => {
                return (
                    <ShoppingBasketSummaryCoverable
                        key={`${coverable.flavourName ?? ''} - ${coverable.fixedId ?? ''}`}
                        coverable={coverable}
                        paymentFrequency={paymentFrequency}
                        paymentFrequencyPostfix={paymentFrequencyPostfix}
                        shouldRenderOverlayDesign={shouldRenderOverlayDesign}
                    />
                );
            })}
        </div>
    );
};

export default ShoppingBasketSummaryCoverableList;
